function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00999a"
    },
    fillRule: "evenodd",
    d: "M27.874 8.77l-2.838 4.14c-.011.015-.028.021-.039.035a.702.702 0 0 1-.168.149c-.025.016-.045.037-.072.049a.67.67 0 0 1-.296.073.674.674 0 0 1-.321-.089c-.011-.006-.024-.003-.036-.01l-4.391-2.642a.722.722 0 0 1-.248-.978.693.693 0 0 1 .961-.251l3.252 1.957c-.635-5.493-5.225-9.77-10.784-9.77-5.989 0-10.863 4.966-10.863 11.069 0 6.103 4.874 11.069 10.863 11.069 3.834 0 7.423-2.093 9.37-5.462a.695.695 0 0 1 .961-.252.722.722 0 0 1 .248.977C21.276 22.637 17.223 25 12.895 25 6.131 25 .63 19.394.63 12.502.63 5.609 6.131.004 12.895.004c6.09 0 11.141 4.55 12.091 10.483l1.738-2.534a.694.694 0 0 1 .976-.179.725.725 0 0 1 .174.996z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLoading);
export default __webpack_public_path__ + "static/media/ico-loading.504ae32550a48f75dbd2269dcd464a4f.svg";
export { ForwardRef as ReactComponent };